import { Box, Tooltip } from '@mui/material';
import type { ComponentProps } from 'react';
import BannerComposition from './banner-composition';

export default function BannerPreviewCell({ banner }: ComponentProps<typeof BannerComposition>) {
  return (
    <Tooltip
      arrow
      placement="left"
      title={<BannerComposition banner={banner} />}
      slotProps={{
        tooltip: { sx: { p: 0.5, bgcolor: 'common.white', boxShadow: 8, maxWidth: 'none' } },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          height: 40,
          justifyContent: 'center',
          width: 72,
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <BannerComposition banner={banner} scale={0.225} />
      </Box>
    </Tooltip>
  );
}
